import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { Router, ActivatedRoute } from '@angular/router';

import { NotificationService } from '../../services/notification.service';
import { UserService } from '../../services/user.service';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { FileTableService } from '../../services/filetable.service';
//import { TransitionCheckState } from '@angular/material/checkbox';
//import Moment from 'react-moment';

let moment = require('moment');

const initStatus = {
  'pending': 0,
  'locked': 0,
  'ready': 0,
  'notsent': 0,
  'late': 0
};

@Component({
  selector: 'nestas-file-table',
  templateUrl: './file-table.component.html',
  styleUrls: ['./file-table.component.scss']
})
export class FileTableComponent implements OnInit {

  @Input() pid;
  @Input() parentPID;
  @Input() files;
  @Input() pending;
  @Input() editable: Boolean;
  @Input() events: Observable<void>;
  @Input() forContractor: boolean = false;
  @Input() onClick;
  @Input() filtered: boolean = true;
  @Input() compact: boolean = false;
  @Input() showfilters: boolean = true;
  @Output() reloadHome = new EventEmitter<string>();

  fileToUpload = null;
  rooms = [];
  showActions = false;
  init = false;
  modal = {
    editPID: false,
    deletePID: false,
    newPID: false,
    transferPID: false,
    pid: null
  };

  allfiles = {
    filtered: [],
    all: [],
    display: []
  };
  filters = {
    'room': [],
    'status': [],
    'pid': [],
  };
  allRoomTypes = [];
  allPIDs = [];
  allStatusTypes = [];
  allStatusCount = { ...initStatus };
  selected = {};

  allStatusTypesSort = ['notsent', 'late', 'pending', 'ready', 'locked'];

  widths = {
    'false': {
      'contractor': {
        'pid': 140,
        'name': 140,
        'type': 140,
        'description': 140,
        'job': 140,
        'deadline': 90
      },
      'owner': {
        'room': 50,
        'type': 180,
        'name': 180,
        'description': 180,
        'deadline': 112
      }
    },
    'true': {
      'contractor': {
        'pid': 140,
        'name': 140,
        'type': 140,
        'description': 140,
        'job': 140,
        'deadline': 90
      },
      'owner': {
        'room': 50,
        'type': 160,
        'name': 160,
        'description': 160,
        'deadline': 90
      }
    }
  }


i = 0;

@Input() count: Number;
  @Input() selection: Boolean;

  private eventsSubscription: any;
  isPhone = false;
  isPad = false;

  constructor(private _notification: NotificationService,
    private _user: UserService, private _router: Router, private _route: ActivatedRoute, public translate: TranslateService,
    private _filetable: FileTableService) {
  }

  getHeight() {
    if (this.compact) return 92;
    return 66;
  }

  getHeaderHeight() {
    if (this.compact) return 0;
    return 55;
  }

  getWidth(x) {
    if (this.compact) {
      return 287;
    }
    return this.widths[this.isPad.toString()][this.forContractor ? 'contractor' : 'owner'][x];
  }

  onToggle(row) {
    console.log("toggle row", row);
  }

  addRoom() {
    this.rooms.push({ room: '' });
  }

  roomSelected(room) {
    return this.filters['room'].includes(room) ? "selected" : "";
  }

  pidSelected(pid) {
    return this.filters['pid'].includes(pid._id) ? "selected" : "";
  }

  statusSelected(room, last) {
    let res = this.filters['status'].includes(room) ? "selected" : "";
    if (last) {
      res += " last";
    }
    return res;
  }

  getStatus = (row) => this._filetable.getStatus(row, this.pid);
  status2imgfn = (status) => this._filetable.status2imgfn(status);
  room2imgfn = (room) => this._filetable.room2imgfn(room);
  contractorClass = (row) => this._filetable.contractorClass(row);
  formatContractor = (row) => this._filetable.formatContractor(row);

  currentSelection() {
    return this.allfiles['filtered'].filter(x => x.checked).map(x => x._id);
  }

  selectAll() {

    this.allfiles['filtered'].forEach(x => {
    })
    this.allfiles['filtered'].forEach(x => {
      if (!(this.pid && this.pid.parentPID && x.sharingType != 'distinct')) {
        x.checked = true;
      }
    })
  }
  selectNone() {
    this.allfiles['filtered'].forEach(x => {
    })

    this.allfiles['filtered'].forEach(x => {
      x.checked = false;
    })
  }

  updateFilter(event) {
    if (!this.filtered && this.init) { return }
    const id = event.target.id || event.target.parentElement.id;

    const val = id.split('_')[3];
    const name = id.split('_')[2];
    const checked = !(this.filters[name].includes(val));

    //console.log("val", id, val, "event", event, "checked", checked, name, this.filters[name]);

    if (checked) {
      this.filters[name].push(val);
    } else {
      const index = this.filters[name].indexOf(val);
      if (index !== -1) {
        this.filters[name].splice(index, 1);
      }
    }
    let qp = {};
    qp['status'] = this.filters['status'].join(',');
    qp['room'] = this.filters['room'].join(',');
    if (this.filters.pid) {
      qp['pid'] = this.filters.pid;
    }
    //console.log("filters query params", qp);
    this._router.navigate(['.'], {
      relativeTo: this._route,
      queryParams: qp,
      queryParamsHandling: 'merge'
    })

    this.doUpdateFilter();
  }

  doUpdateFilter() {
    //if (this.shared) { console.log("shared 2"); return}
    // filter our data
    var parent = this;
    const temp = this.allfiles['display'].filter(function (d) {
      if (parent.forContractor) {
        var left = (!parent.filters['pid'].length || ((d.PID && parent.filters['pid'].indexOf(d.PID._id) > -1) || (d.PID && d.PID.parentPID && parent.filters['pid'].indexOf(d.PID.parentPID._id) > -1)));
      } else {
        var left = (!parent.filters['room'].length || (parent.filters['room'].indexOf(d.room) > -1));
      }
      let right = (!parent.filters['status'].length || (parent.filters['status'].indexOf(d['status']) > -1));
      return left && right;
    });
    // update the rows
    this.allfiles['filtered'] = temp;

    /*this.allfiles['filtered'].forEach(x => {
      x.checked = false;
    })*/
    // Whenever the filter changes, always go back to the first page
  }

  updateData = () => {
    if (this.init && !this.filtered) { return }
    this.allfiles = {
      all: [...this.pending.all, ...this.files.all],
      display: [...this.pending.display, ...this.files.display],
      filtered: [[], []]
    };

    this.allRoomTypes = Array.from(new Set(this.allfiles['all'].map(item => item.room))).sort((a, b) => a.localeCompare(b));
    var knownPIDs = [];
    var allPIDs = [];

    this.allStatusCount = { ...initStatus };
    //console.log("init allstatus count", this.allStatusCount, initStatus);

    this.allfiles['all'].forEach(item => {
      let status = this.getStatus(item);
      item['status'] = status;
      this.allStatusCount[status] += 1;
      //console.log(item['name'], status);

      if (this.forContractor) {
        if (item.PID && !item.PID.parentPID && knownPIDs.indexOf(item.PID._id) == -1) {
          knownPIDs.push(item.PID._id.toString());
          allPIDs.push(item.PID);
        }

        if (item.PID && item.PID.parentPID && item.PID.parentPID._id && knownPIDs.indexOf(item.PID.parentPID._id.toString()) == -1) {
          knownPIDs.push(item.PID.parentPID._id.toString());
          allPIDs.push(item.PID.parentPID);
        }
      }

      this.allPIDs = allPIDs;
    });

    if (this.forContractor) {
      this.allPIDs.sort((a, b) => {
        var nameA = a.name.toUpperCase();
        var nameB = b.name.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }

        // names must be equal
        return 0;
      });
    }

    if (this.forContractor) {
      this.allStatusTypes = ['pending', 'late', 'ready'];
    } else {
      this.allStatusTypes = ['notsent', 'pending', 'late', 'ready', 'locked'];
    }
    this.doUpdateFilter();
  }

  ngOnDestroy() {
    if (this.eventsSubscription) {
      this.eventsSubscription.unsubscribe();
    }
  }

  ngOnInit() {
    this.isPhone = window.matchMedia('(max-width: 767px)').matches;
    this.isPad = window.matchMedia('(max-width: 1080px)').matches;
    //console.log("phone/pad", this.isPhone, this.isPad);
    this._filetable.forContractor = this.forContractor;

    if (this.forContractor) {
      this.filters.status = ['pending', 'late'];
    } else {
      this.filters.status = ['notsent', 'pending', 'late', 'ready', 'locked'];
    }

    //console.log("file table on init", this.pid, this.forContractor, "default filters", this.filters.status);

    if (this.pid) {
      let pid = this.pid.parentPID || this.pid._id;
      //console.log("file table default pid", pid, this.pid, this.pid.parentPID);
      this.filters.pid = [pid];
    }

    if (this.events) {
      this.eventsSubscription = this.events.subscribe(() => {
        this.doUpdateFilter();
      })
    }

    //this.updateData();
    this._route.queryParams.subscribe(params => {
      //console.log("file table oinit params", params);

      ['status', 'room', 'pid'].forEach(x => {
        if (params.hasOwnProperty(x)) {
          if (Array.isArray(params[x])) {
            this.filters[x] = params[x];
          } else {
            this.filters[x] = params[x].split(',').filter(x => x);
          }
        }
      });
      this.updateData();
      this.init = true;
    });
  }

  goToFileDetails(row) {
    if (this.forContractor) {
      if (this.onClick) {
        this.onClick(row);
      }
    } else {
      this._router.navigate(['file', row._id, this.pid._id]);
    }
  }

  onActivate(event) {

    if (event.type == 'click' && !this.selection) {
      console.log("on activate", event.column.prop, event.row, this.selection);
      return this.goToFileDetails(event.row);
    }
  }

  getColor() {
    return this.pid['percentage'] > 70 ? "primary"
      : this.pid['percentage'] > 40 ? "accent"
        : "warn";
  }

  fileChangeEvent(fileInput) {
    var file = fileInput.target.files[0];
    this.fileToUpload = fileInput.target.files[0];
    this.pid.file = { type: file.type, name: file.name }
  }

  stringify(data) {
    return JSON.stringify(data);
  }

  fallbackImg($event) {
    $event.target.src = '/assets/' + this.pid.type + '.png';
  }

  details(pid) {
    if (this.editable) {
      this._router.navigate(['pid', pid._id]);
    }
  }

  displayActions() {
    if (this.editable) {
      this.showActions = true
    }
  }

  comparator(propA, propB) {
    let a = propA.trim().toLowerCase().replace(/"/g, "");
    let b = propB.trim().toLowerCase().replace(/"/g, "");

    if (a < b) {
      return -1;
    }
    if (a > b) {
      return 1;
    }
  }


  statusComparator = (propA, propB, rowA, rowB) => {

    var a = rowA['status'].trim().toLowerCase();
    var b = rowB['status'].trim().toLowerCase();

    a = this.allStatusTypesSort.indexOf(a);
    b = this.allStatusTypesSort.indexOf(b);

    if (a == b) {
      a = rowA['name'].trim().toLowerCase().replace(/"/g, "");
      b = rowB['name'].trim().toLowerCase().replace(/"/g, "");
    }

    if (a < b) {
      return -1;
    }

    if (a > b) {
      return 1;
    }

    return 0;
  }


  userIsAllowed() {
    return !this._user.expired() && !this.pid.expired;
  }

  useremail() {
    return this._user.me()['email'];
  }

  reload() {
    this.reloadHome.next('');
  }

}
